import { gql } from "@apollo/client";

export const packageFragment = gql`
    fragment PackageFragment on Package {
        id
        country
        name
        description
        type
        validTimeInMonths
        createdAt
    }
`;
